/*
 * @Author: mrzou
 * @Date: 2021-08-10 10:43:08
 * @LastEditors: mrzou
 * @LastEditTime: 2021-08-12 17:55:38
 * @Description: file content
 */
export default {
  namespaced: true,
  state() {
    return {
      // 购物车中的商品列表
      selecteds: [],
      // 用户银豆数量
      silver_bean_num: 0,
      // 从本地存储 获取到的商品数据
      lcDatas: []
    }
  },
  mutations: {
    setSelecteds(state, data = []) {
      state.selecteds = data.filter(item => item.value)
    },
    setSilverBeanNum(state, val) {
      state.silver_bean_num = val
    },
    setLcDatas(state, val) {
      state.lcDatas = val
    },
    emptyCart(state) {
      state.selecteds = []
      state.lcDatas = []
    }
  },
  getters: {},
  actions: {}
}
